// extracted by css-extract-rspack-plugin
export default {"MPTable":"MPTable-TnrzID","mpTable":"MPTable-TnrzID"};